<template>
  <div>
    <header class="hero-multi">
      <div class="bb-container">
        <div class="hero-multi__container">
          <div class="hero-multi__left">
            <h1 class="hero-multi__title">
              La wishlist
              <span class="hero-multi__break">multistore</span> per tutto ciò che desideri
            </h1>
            <div class="hero-multi__actions">
              <bbButton
                label="Crea la tua wishlist"
                class="button--lg button--accent"
                @click="$router.push({ name: 'registrazione' })"
              />
              <!-- <a
                  @click="$router.push({ name: 'guest', params: { id: exampleListId } })"
                  class="link link--bold link--underline"
                >
                  Ver una lista de ejemplo
                </a> -->
            </div>
          </div>
          <div class="hero-multi__cover">
            <picture>
              <source
                srcset="../../assets/img/covers/cover-fr-hero@2x.png"
                media="(min-width: 1399px) and (min-device-pixel-ratio: 2)"
              />
              <img src="../../assets/img/covers/cover-multi-hero.webp" alt="" />
            </picture>
          </div>
        </div>
      </div>
    </header>
    <section class="rate-app">
      <div class="bb-container">
        <div class="rate-app__container">
          <div class="rate-app__title">
            Più di 150.000 persone hanno creato <br />la loro wishlist con HelloWish
          </div>
          <div class="rate-app__card">
            <div class="rate-app__item">
              <div class="rate-app__logo">
                <img src="../../assets/img/ico/ico-google-play.svg" alt="Google Play" />
              </div>
              <div class="rate-app__rate">4,8</div>
              <div class="rate-app__star">
                <img src="../../assets/img/ico/ico-star-fill.svg" alt="" />
              </div>
            </div>
            <hr />
            <div class="rate-app__item">
              <div class="rate-app__logo">
                <img src="../../assets/img/ico/ico-app-store.svg" alt="Apple App Store" />
              </div>
              <div class="rate-app__rate">4,8</div>
              <div class="rate-app__star">
                <img src="../../assets/img/ico/ico-star-fill.svg" alt="" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="tiendas-list">
      <div class="tiendas-list__title">Aggiungi prodotti da qualsiasi negozio</div>
      <div class="tiendas-list__items">
        <VueSlickCarousel v-bind="shopSlider">
          <!-- <div class="tiendas-list__item">
              <img loading="lazy" src="../../assets/img/logos/logo-af-corte-ingles.svg" />
            </div> -->
          <div class="tiendas-list__item">
            <img
              loading="lazy"
              src="../../assets/img/logos/logo-af-amazon.svg"
              alt="Amazon"
            />
          </div>
          <div class="tiendas-list__item">
            <img
              loading="lazy"
              src="../../assets/img/logos/logo-af-ikea.svg"
              alt="IKEA"
            />
          </div>
          <div class="tiendas-list__item">
            <img
              loading="lazy"
              src="../../assets/img/logos/logo-af-etsy.svg"
              alt="Etsy"
            />
          </div>
          <div class="tiendas-list__item">
            <img
              loading="lazy"
              src="../../assets/img/logos/logo-af-sephora.svg"
              alt="Sephora"
            />
          </div>
          <div class="tiendas-list__item">
            <img
              loading="lazy"
              src="../../assets/img/logos/zalando-logo.svg"
              alt="Zalando"
            />
          </div>
          <div class="tiendas-list__item">
            <img loading="lazy" src="../../assets/img/logos/logo-af-hm.svg" alt="H & M" />
          </div>
          <div class="tiendas-list__item">
            <img
              loading="lazy"
              src="../../assets/img/logos/logo-af-maisons.svg"
              alt="Maisons du monde"
            />
          </div>
          <div class="tiendas-list__item">
            <img
              loading="lazy"
              src="../../assets/img/logos/logo-af-zara.svg"
              alt="Zara"
            />
          </div>
          <div class="tiendas-list__item">
            <img
              loading="lazy"
              src="../../assets/img/logos/logo-fr-kiavi.svg"
              alt="Kiavi"
            />
          </div>
        </VueSlickCarousel>
      </div>
    </section>
    <section class="hbbm-verticales">
      <div class="hbbm-verticales__container bb-container">
        <h3 class="hbbm-verticales__title">Ideale per <span>tutte le occasioni</span></h3>
        <div class="hbbm-verticales__items">
          <VueSlickCarousel v-bind="verticalesSlider" dotsClass="slick-dots">
            <div
              class="hbbm-verticales__item"
              v-for="item in verticales"
              :key="item.name"
            >
              <component
                :is="item.path ? 'router-link' : 'div'"
                :to="item.path || undefined"
                class="hbbm-verticales__content"
              >
                <div class="hbbm-verticales__name">
                  {{ item.name }}
                </div>
                <picture class="hbbm-verticales__image">
                  <img :src="item.cover" :alt="item.name" />
                </picture>
              </component>
            </div>
          </VueSlickCarousel>
        </div>
      </div>
    </section>
    <section class="app-avanzada">
      <div class="bb-container">
        <div class="app-avanzada__container">
          <aside class="app-avanzada__left">
            <div class="app-avanzada__title">
              La migliore App per le tue liste dei desideri è <span>gratuita</span>
            </div>
            <div class="app-avanzada__description">
              Scopri la nostra App gratuita con tutto il necessario per realizzare la tua
              wishlist perfetta.
            </div>
            <!-- <div class="app-avanzada__actions">
                Descubre nuestra App gratuita con todo lo que necesitas para hacer tu lista
                perfecta.
              </div> -->
            <div class="app-avanzada__stores">
              <a :href="$t('links.mobileAppUrlAndroid', 'it-IT')" target="_blank">
                <img
                  loading="lazy"
                  src="../../assets/img/logos/logo-app-android-it.png"
                  alt=""
                  width="140"
                  height="40"
                />
              </a>
              <a :href="$t('links.mobileAppUrlIos', 'it-IT')" target="_blank">
                <img
                  loading="lazy"
                  src="../../assets/img/logos/logo-app-apple-it.svg"
                  alt=""
                  width="140"
                  height="40"
                />
              </a>
            </div>
          </aside>
          <picture class="app-avanzada__cover">
            <img
              src="../../assets//img/covers/mockup_lista_general_IT.png"
              :alt="$t('home2.appTitle')"
            />
          </picture>
        </div>
      </div>
    </section>
    <main class="home-beneficios">
      <div class="bb-container">
        <div class="home-beneficios__items">
          <section class="home-beneficios__item">
            <div class="home-beneficios__cover">
              <img src="../../assets/img/covers/cover-multi-bolso-iphone.webp" alt="" />
            </div>
            <div class="home-beneficios__right">
              <div class="home-beneficios__title">
                Scegli qualsiasi prodotto da qualsiasi negozio
              </div>
              <div class="home-beneficios__description">
                Hai la totale libertà di scegliere proprio quello che vuoi.
              </div>
              <ul class="home-beneficios__list">
                <li>Prodotti unici di piccoli brand</li>
                <li>Le migliori offerte dei grandi magazzini</li>
              </ul>
            </div>
          </section>
          <section class="home-beneficios__item">
            <div class="home-beneficios__cover">
              <img
                src="../../assets//img/covers/cover-multi-recibiendo-dinero-002-it.webp"
                alt="Lista para recibir dinero en tu hucha."
              />
            </div>
            <div class="home-beneficios__right">
              <div class="home-beneficios__title">
                Pronta a ricevere denaro nel tuo salvadanaio
              </div>
              <div class="home-beneficios__description">
                La tua wishlist include un salvadanaio con il quale potrai raccogliere
                denaro per acquisti specifici o per altri progetti.
              </div>
              <div class="home-beneficios__actions">
                <div
                  class="link link--bold link--underline"
                  @click="$router.push({ name: 'salvadanaio-di-nascita' })"
                >
                  Per maggiori informazioni
                </div>
              </div>
            </div>
          </section>
          <section class="home-beneficios__item">
            <div class="home-beneficios__cover">
              <img
                src="../../assets//img/covers/monitorizacion-precios-wishlist-IT.webp"
                alt="Ofrece la posibilidad de compartir las compras más caras"
              />
            </div>
            <div class="home-beneficios__right">
              <div class="home-beneficios__title">
                Compra al momento giusto
              </div>
              <div class="home-beneficios__description">
                Ti facciamo sapere se cambiano i prezzi dei tuoi prodotti preferiti.
              </div>
              <div class="home-beneficios__footnote">
                *Controlliamo solo i prezzi dei nostri negozi partner.
              </div>
            </div>
          </section>
          <section class="home-beneficios__item">
            <div class="home-beneficios__cover home-beneficios__cover--rounded">
              <img
                src="../../assets/img/covers/promos_home.webp"
                alt="Non perderti neanche un’offerta"
              />
            </div>
            <div class="home-beneficios__right">
              <div class="home-beneficios__title">
                Non perderti neanche un’offerta
              </div>
              <div class="home-beneficios__description">
                Approfitta delle offerte dei tuoi negozi preferiti direttamente dalla tua lista dei desideri.
              </div>
              <div class="home-beneficios__actions">
                <a
                  class="link link--bold link--underline"
                  :href="$t('routes.deals', 'it-IT')"
                >
                  Scopri di più
                </a>
              </div>
            </div>
          </section>
        </div>
      </div>
    </main>
    <div class="feedback-int">
      <div class="bb-container">
        <div class="feedback-int__title">Alcune belle parole dei nostri utenti</div>
        <div class="feedback-int__items">
          <VueSlickCarousel v-bind="reviewsSlider">
            <div class="feedback-int__item">
              <div class="feedback-user">
                <div class="feedback-user__cover">
                  <img src="../../assets/img/covers/testimonial-marta.jpg" alt="" />
                </div>
                <div class="feedback-user__content">
                  <div class="feedback-user__string">
                    "Applicazione super consigliata e utile per creare liste regalo, che
                    sia per l’arrivo di un bambino, un battesimo o un compleanno."
                  </div>
                  <div class="feedback-user__name">Marta</div>
                </div>
              </div>
            </div>
            <div class="feedback-int__item">
              <div class="feedback-user">
                <div class="feedback-user__cover">
                  <img src="../../assets/img/covers/testimonial-estefania.jpg" alt="" />
                </div>
                <div class="feedback-user__content">
                  <div class="feedback-user__string">
                    "Esattamente quello che cercavo. Non limitarmi a un solo negozio o a
                    un solo sito web per fare la mia lista dei desideri.”
                  </div>
                  <div class="feedback-user__name">Stefania</div>
                </div>
              </div>
            </div>
            <div class="feedback-int__item">
              <div class="feedback-user">
                <div class="feedback-user__cover">
                  <img src="../../assets/img/covers/testimonial-ichamar.jpg" alt="" />
                </div>
                <div class="feedback-user__content">
                  <div class="feedback-user__string">
                    “Un’app molto pratica per individuare ciò di cui hai bisogno, inviarlo
                    ai tuoi contatti e gestire il tuo budget.”
                  </div>
                  <div class="feedback-user__name">Piero</div>
                </div>
              </div>
            </div>
          </VueSlickCarousel>
        </div>
      </div>
    </div>

    <section class="multi-share">
      <div class="bb-container">
        <div class="multi-share__container">
          <article class="multi-share__article">
            <div class="multi-share__title">Condividi facilmente i tuoi desideri</div>
            <div class="multi-share__description">
              Condividere la tua lista è facile come copiare e incollare un collegamento.
              La tua famiglia e i tuoi amici non dovranno registrarsi o scaricare nulla.
            </div>
          </article>
          <picture class="multi-share__cover">
            <img
              src="../../assets/img/covers/cover-multi-men-share.webp"
              alt="Comparte tus deseos fácilmente"
            />
          </picture>
        </div>
      </div>
    </section>

    <section class="cta-yellow-deseos">
      <div class="bb-container">
        <div class="cta-yellow-deseos__cta">
          <div class="cta-yellow-deseos__left">
            <div class="cta-yellow-deseos__title">
              Crea la tua wishlist con ciò che più ti piace di ogni negozio.
            </div>
            <div class="cta-yellow-deseos__actions">
              <bbButton
                label="Crea la tua wishlist"
                class="button--accent button--lg"
                @click="$router.push({ name: 'registrazione' })"
              />
              <!-- <div
                class="link link--bold link--underline"
                @click="$router.push({ name: 'guest', params: { id: exampleListId } })"
              >
                Vedi un esempio di lista
              </div> -->
            </div>
          </div>
          <div class="cta-yellow-deseos__cover">
            <img src="../../assets/img/covers/cover-multi-ext-share.webp" alt="" />
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import VueSlickCarousel from "vue-slick-carousel";
import "vue-slick-carousel/dist/vue-slick-carousel.css";
import "vue-slick-carousel/dist/vue-slick-carousel-theme.css";

import bbButton from "../../components/buttons/bbButton.vue";

export default {
  name: "HomePageES",
  metaInfo() {
    return {
      script: [
        {
          type: "application/ld+json",
          json: {
            "@context": "https://schema.org",
            "@type": "SoftwareApplication",
            name: "HelloWish",
            operatingSystem: [
              //no estic segur del format per posar més d’un valor
              "ANDROID",
              "IOS",
            ],
            applicationCategory: "LifestyleApplication",
            aggregateRating: {
              "@type": "AggregateRating",
              ratingValue: "4.5", //no aconsegueixo veure ratings, tu pots?
              ratingCount: "20", //no aconsegueixo veure ratings, tu pots?
            },
            offers: {
              "@type": "Offer",
              price: "0",
            },
          },
        },
        {
          type: "application/ld+json",
          json: {
            "@context": "https://schema.org",
            "@type": "Organization",
            name: "HelloWish",
            legalName: "HelloBB S.L.",
            url: "https://www.hellobb.net",
            logo: "https://www.hellobb.net/logo-hellobb-dark.svg", //posar URL on tenim el logo
            description: "HelloWish, la tua lista dei desideri senza limiti.",
            foundingDate: "2022",
            address: {
              "@type": "PostalAddress",
              streetAddress: "C/ Pompeu Fabra 36",
              addressLocality: "Tortosa",
              addressRegion: "Tarragona",
              postalCode: "43500",
              addressCountry: {
                "@type": "Country",
                name: "Spain", //en anglés millor?
              },
            },
            contactPoint: {
              "@type": "ContactPoint",
              contactType: "customer support",
              email: "hola@hellobb.net",
            },
            sameAs: [
              "https://www.instagram.com/holahellobebe/",
              "https://www.facebook.com/holahelloBB",
              "https://www.pinterest.es/holahelloBB/",
              "https://www.crunchbase.com/organization/hellobb",
            ],
          },
        },
      ],
      title: "HelloWish, la tua lista dei desideri senza limiti.",
      htmlAttrs: {
        lang: "it",
      },
      meta: [
        {
          name: "description",
          content:
            "Salva prodotti di qualsiasi negozio, raccogli fondi, condividi facilmente... Scopri la migliore lista di desideri.",
        },
        {
          itemprop: "image",
          content: "https://www.hellobb.net/images/cover-portada.08a0882.png",
        },
        {
          property: "og:url",
          content: "https://www.hellobb.net",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          property: "og:title",
          content: "HelloWish, la tua lista dei desideri senza limiti.",
        },
        {
          property: "og:description",
          content:
            "Salva prodotti di qualsiasi negozio, raccogli fondi, condividi facilmente... Scopri la migliore lista di desideri.",
        },
        {
          property: "og:image",
          content: "https://www.hellobb.net/images/cover-portada.08a0882.png",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
        {
          name: "twitter:title",
          content: "HelloWish, la tua lista dei desideri senza limiti.",
        },
        {
          name: "twitter:description",
          content:
            "Salva prodotti di qualsiasi negozio, raccogli fondi, condividi facilmente... Scopri la migliore lista di desideri.",
        },
        {
          name: "twitter:image",
          content: "https://www.hellobb.net/images/cover-portada.08a0882.png",
        },
      ],
      link: [
        { rel: "canonical", href: "https://www.hellobb.net/it" },
        { rel: "alternate", href: "https://www.hellobb.net", hreflang: "es" },
        { rel: "alternate", href: "https://www.hellobb.net/en", hreflang: "en" },
        { rel: "alternate", href: "https://www.hellobb.net/fr", hreflang: "fr" },
        { rel: "alternate", href: "https://www.hellobb.net/it", hreflang: "it" },
        { rel: "alternate", href: "https://www.hellobb.net/nl", hreflang: "nl" },
        { rel: "alternate", href: "https://www.hellobb.net/de", hreflang: "de" },
        { rel: "alternate", href: "https://www.hellobb.net/pt", hreflang: "pt" },
        { rel: "alternate", href: "https://www.hellobb.net", hreflang: "x-default" }
      ],
    };
  },
  components: {
    bbButton,
    VueSlickCarousel,
  },
  data() {
    return {
      verticales: [
        { name: "Lista nascita", path: "/lista-di-nascita", cover: "/cover-hbbm-mujer-cuna.jpg" },
        { name: "Lista nozze", path:"/landing/lista-nozze", cover: "/cover-hbbm-wedding.jpg" },
        { name: "Lista compleanno", cover: "/cover-hbbm-globos.jpg" },
        { name: "Lista di Natale", cover: "/cover-hbbm-navidad.jpg" },
        {
          name: "Lista baby shower",
          path: "/lista-di-nascita",
          cover: "/cover-hbbm-babby-shower.jpg",
        },
        { name: "Lista battesimo", cover: "/cover-hbbm-bautizo.jpg" },
      ],
      verticalesSlider: {
        slidesToShow: 4,
        arrows: false,
        autoplay: true,
        dots: false,
        slidesToScroll: 1,
        centerMode: true,
        speed: 900,
        responsive: [
          {
            breakpoint: 991,
            settings: {
              slidesToShow: 4,
            },
          },
          {
            variableWidth: true,
            breakpoint: 767,
            settings: {
              slidesToShow: 1,
              dots: true,
            },
          },
        ],
      },
      shopSlider: {
        slidesToShow: 8,
        arrows: false,
        autoplay: true,
        dots: false,

        slidesToScroll: 1,
        centerMode: true,
        centerPadding: "20px",
        edgeFriction: 0.35,
        speed: 500,
        responsive: [
          {
            breakpoint: 1000000,
            settings: {
              slidesToShow: 8,
              // variableWidth: true,
            },
          },
          {
            breakpoint: 991,
            settings: {
              slidesToShow: 4,
            },
          },
          {
            variableWidth: true,
            breakpoint: 767,
            settings: {
              // autoplay: false,
              slidesToShow: 2,
              variableWidth: true,
            },
          },
        ],
      },
      reviewsSlider: {
        slidesToShow: 3,
        arrows: false,
        autoplay: true,
        slidesToScroll: 1,
        responsive: [
          {
            breakpoint: 991,
            settings: {
              slidesToShow: 2,
            },
          },
          {
            breakpoint: 767,
            settings: {
              centerMode: true,
              slidesToShow: 1,
            },
          },
        ],
      },
    };
  },
  computed: {
    exampleListId() {
      return process.env.PREVIEW_LIST_IT_ID;
    },
  },
};
</script>

<style lang="scss" scoped></style>
